
import React from 'react';
import Layout from '@/components/layout/Layout';
import FarmUpload from '@/components/farms/FarmUpload';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const FarmUploadPage: React.FC = () => {
  const navigate = useNavigate();

  const handleUploadComplete = () => {
    // Wait a bit before redirecting to the farms list
    setTimeout(() => {
      navigate('/farms');
    }, 3000);
  };

  return (
    <Layout>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Upload Farms</h1>
        <Button variant="outline" size="sm" onClick={() => navigate('/farms')}>
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Farms
        </Button>
      </div>
      
      <div className="bg-white rounded-lg shadow p-6">
        <div className="max-w-xl mx-auto">
          <FarmUpload onUploadComplete={handleUploadComplete} />
        </div>
      </div>
    </Layout>
  );
};

export default FarmUploadPage;
